
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequiref920"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequiref920"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("2A2ZL", function(module, exports) {

$parcel$export(module.exports, "init", function () { return $f29b64522dc0a459$export$2cd8252107eb640b; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $01JF1 = parcelRequire("01JF1");

var $hOqV7 = parcelRequire("hOqV7");

var $cGDYS = parcelRequire("cGDYS");

var $7RyUO = parcelRequire("7RyUO");

var $dunoe = parcelRequire("dunoe");

var $200NX = parcelRequire("200NX");

var $kNCWT = parcelRequire("kNCWT");

var $j0nzO = parcelRequire("j0nzO");

var $14zFQ = parcelRequire("14zFQ");

var $dJ4mM = parcelRequire("dJ4mM");

var $1FD73 = parcelRequire("1FD73");

var $6wlNh = parcelRequire("6wlNh");

var $k2OeR = parcelRequire("k2OeR");

var $9uFWm = parcelRequire("9uFWm");

var $9Dbz6 = parcelRequire("9Dbz6");
window.BUILD_KEY = "p-7aebfab68a";
window.featureGateBootstrapValues = window.featureGateBootstrapValues || {
    identifiers: {
        analyticsAnonymousId: (0, $cGDYS.default)()
    }
};
const $f29b64522dc0a459$export$2cd8252107eb640b = (Component, query, queryVars, relayApi)=>{
    const analyticsWebClient = (0, $dunoe.getAnalyticsWebClient)();
    const { locale: locale, path: path } = (0, $9Dbz6.parseRoute)(window.location);
    (0, $k2OeR.isPerformanceOnetrustEnabled)() && (0, $7RyUO.initUFO)(analyticsWebClient, path);
    if ((0, $6wlNh.isEdgeCachingPath)(window.location.pathname)) {
        // Override for Edge Caching
        (0, $6wlNh.overrideAjsAnonIdFromCookie)();
        (0, $6wlNh.overrideCustomAttributes)();
    }
    (0, $j0nzO.initializeFeatureGatesClient)(window.featureGateBootstrapValues).then(()=>{
        const isStatic = typeof window !== "undefined" && window.IS_STATIC;
        const snapshot = window.relayStoreSnapshot;
        let relayBaseUrl = undefined;
        let relayAuthKey = undefined;
        if (relayApi === (0, $200NX.RELAY_API_CONTENTFUL)) {
            relayBaseUrl = (0, $kNCWT.CONTENTFUL_GRAPHQL_API_URL);
            relayAuthKey = window.CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES;
        }
        const relayEnvironment = (0, $1FD73.initRelayEnvironment)(snapshot, relayBaseUrl, relayAuthKey);
        const queryRef = (0, $hOqV7.loadQuery)(relayEnvironment, query, queryVars);
        if (isStatic) {
            // @ts-ignore
            const root = (0, $01JF1.createRoot)(document.getElementById("wac"));
            root.render(/*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
                locale: locale,
                messages: window.SSR_languagePack,
                cookies: document.cookie,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hOqV7.RelayEnvironmentProvider), {
                    environment: relayEnvironment,
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dJ4mM.PageWrapper), {
                        analyticsWebClient: analyticsWebClient,
                        pureClientMode: true,
                        location: window.location,
                        pricing: window.prices,
                        availableProducts: window.availableProducts,
                        userProfile: window.userProfile,
                        userProfileStatus: window.userProfileStatus,
                        userContext: window.userContext,
                        userContextStatus: window.userContextStatus,
                        loggedOutContext: window.loggedOutContext,
                        loggedOutContextStatus: window.loggedOutContextStatus,
                        countryCode: window.countryCode,
                        mlTemplateIds: window.mlTemplateIds,
                        keyword: window.keyword,
                        subAnchor: window.subAnchor,
                        auxiaResponse: window.auxiaResponse,
                        queryRef: queryRef,
                        userAgent: window.navigator.userAgent,
                        children: Component
                    })
                })
            }));
        } else (0, $01JF1.hydrateRoot)(// @ts-ignore
        document.getElementById("wac-root"), /*#__PURE__*/ (0, $loA2J.jsx)((0, $9uFWm.SentryIntlProvider), {
            locale: locale,
            messages: window.SSR_languagePack,
            cookies: document.cookie,
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $hOqV7.RelayEnvironmentProvider), {
                environment: relayEnvironment,
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $14zFQ.Layout), {
                    analyticsWebClient: analyticsWebClient,
                    location: window.location,
                    pricing: window.prices,
                    availableProducts: window.availableProducts,
                    userProfile: window.userProfile,
                    userProfileStatus: window.userProfileStatus,
                    userContext: window.userContext,
                    userContextStatus: window.userContextStatus,
                    loggedOutContext: window.loggedOutContext,
                    loggedOutContextStatus: window.loggedOutContextStatus,
                    countryCode: window.countryCode,
                    mlTemplateIds: window.mlTemplateIds,
                    keyword: window.keyword,
                    subAnchor: window.subAnchor,
                    auxiaResponse: window.auxiaResponse,
                    queryRef: queryRef,
                    children: Component
                })
            })
        }), {
            onRecoverableError: (error, errorInfo)=>{
                document.getElementById("wac-root")?.setAttribute("hydration-error", "true");
            }
        });
    });
};

});
parcelRegister("200NX", function(module, exports) {

$parcel$export(module.exports, "RELAY_API_CONTENTFUL", function () { return $52ea49f8e16543b5$export$7b31a9938ec3ba75; });
const $52ea49f8e16543b5$export$7b31a9938ec3ba75 = "contentful";

});

parcelRegister("1FD73", function(module, exports) {

$parcel$export(module.exports, "initRelayEnvironment", function () { return $7d9774703a666878$export$1456be3de97c862f; });

var $4PJsz = parcelRequire("4PJsz");
(0, $4PJsz.RelayFeatureFlags).ENABLE_LOAD_QUERY_REQUEST_DEDUPING = true;
// TODO: Lift this into environment
const $7d9774703a666878$var$GATEWAY_URL = "https://www.atlassian.com/gateway/api/graphql";
function $7d9774703a666878$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken) {
    const baseUrl = baseUrlOverride ?? $7d9774703a666878$var$GATEWAY_URL;
    let headers = {
        "Content-Type": "application/json"
    };
    if (authToken) headers = Object.assign({}, headers, {
        Authorization: `Bearer ${authToken}`
    });
    const fetchResponse = (params, variables)=>{
        const startTime = Date.now();
        const response = fetch(baseUrl, {
            method: "POST",
            headers: headers,
            // Contentful uses an authToken, and Access-Control-Allow-Origin = "*",
            // therefore we cannot include credentials for Contentful queries
            credentials: authToken ? "same-origin" : "include",
            body: JSON.stringify({
                query: params.text,
                variables: variables
            })
        });
        return (0, $4PJsz.Observable).from(response.then(async (res)=>{
            const duration = Date.now() - startTime;
            if (!globalThis.IS_STATIC) try {
                // @ts-ignore
                globalThis.metrics.histogram(`contentful.duration`, "10_100_500_1000_2000_3000_5000_10000_30000", duration, {
                    gqlOperationName: params.name,
                    cacheStatus: res.headers.get("x-cache"),
                    status: res.status
                });
            } catch (e) {
                console.error(`Failed to track ${params.name} call`, e);
            }
            return res.json();
        }));
    };
    const network = (0, $4PJsz.Network).create(fetchResponse);
    const store = new (0, $4PJsz.Store)(new (0, $4PJsz.RecordSource)(initialRecords));
    return new (0, $4PJsz.Environment)({
        network: network,
        store: store
    });
}
let $7d9774703a666878$var$clientSideRelayEnvironment;
function $7d9774703a666878$export$1456be3de97c862f(initialRecords, baseUrlOverride, authToken) {
    const environment = $7d9774703a666878$var$clientSideRelayEnvironment ?? $7d9774703a666878$var$createRelayEnvironment(initialRecords, baseUrlOverride, authToken);
    if (typeof window === "undefined") return environment;
    if (!$7d9774703a666878$var$clientSideRelayEnvironment) $7d9774703a666878$var$clientSideRelayEnvironment = environment;
    else if (initialRecords) environment.getStore().publish(new (0, $4PJsz.RecordSource)(initialRecords));
    return $7d9774703a666878$var$clientSideRelayEnvironment;
}

});


parcelRegister("hWj1i", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplateCollectionDetailsRelayPage", function () { return $6b85e55564396eda$export$bc0513752517fd32; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $jEcgL = parcelRequire("jEcgL");

var $gAJUc = parcelRequire("gAJUc");
const $6b85e55564396eda$export$bc0513752517fd32 = ({ queryRef: queryRef })=>{
    (0, $iSvIT.useEffect)(()=>{
        (0, $gAJUc.checkFeatureFlagGate)((0, $gAJUc.featureFlags).cpapiwdConfluenceTemplateCollectionDetails);
    }, []);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $jEcgL.ConfluenceTemplateCollectionDetailsRelayPageTemplate), {
        queryRef: queryRef
    });
};

});
parcelRegister("jEcgL", function(module, exports) {

$parcel$export(module.exports, "ConfluenceTemplateCollectionDetailsRelayPageQuery", function () { return $49b481e230a25c99$export$98e1975bc3089d34; });
$parcel$export(module.exports, "getConfluenceTemplateCollectionDetailsRelayPageQueryVars", function () { return $49b481e230a25c99$export$fcca656ba7c9c75a; });
$parcel$export(module.exports, "ConfluenceTemplateCollectionDetailsRelayPageTemplate", function () { return $49b481e230a25c99$export$b6f88ef369f9fcd; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");

var $4ktyF = parcelRequire("4ktyF");

var $lHB9W = parcelRequire("lHB9W");

var $lGc56 = parcelRequire("lGc56");

var $a8pnN = parcelRequire("a8pnN");

var $UKzss = parcelRequire("UKzss");

var $3vcPX = parcelRequire("3vcPX");

var $jiTf1 = parcelRequire("jiTf1");

var $h6y9u = parcelRequire("h6y9u");
var $49b481e230a25c99$var$_confluenceTemplateCollectionDetailsRelayPageQuery;
const $49b481e230a25c99$var$contentWrapper = null;
const $49b481e230a25c99$var$parseCollectionUrlSlug = (pathname)=>{
    const [urlSlug, maybeCollectionsSlug] = pathname.split("/").reverse();
    return urlSlug && maybeCollectionsSlug === "collections" ? urlSlug : "";
};
const $49b481e230a25c99$var$RELATED_COLLECTION_URL_SLUGS = {
    ["project-management"]: [
        "product-managers",
        "strategic-planning"
    ],
    ["strategic-planning"]: [
        "project-management",
        "product-managers"
    ]
};
const $49b481e230a25c99$var$DEFAULT_RELATED_COLLECTION_URL_SLUGS = [
    "project-management",
    "strategic-planning"
];

const $49b481e230a25c99$export$98e1975bc3089d34 = $49b481e230a25c99$var$_confluenceTemplateCollectionDetailsRelayPageQuery !== void 0 ? $49b481e230a25c99$var$_confluenceTemplateCollectionDetailsRelayPageQuery : ($49b481e230a25c99$var$_confluenceTemplateCollectionDetailsRelayPageQuery = (parcelRequire("8wWZU")), $49b481e230a25c99$var$_confluenceTemplateCollectionDetailsRelayPageQuery.hash && $49b481e230a25c99$var$_confluenceTemplateCollectionDetailsRelayPageQuery.hash !== "732359a6944a3fa6a17b0037c5a47b87" && console.error("The definition of 'confluenceTemplateCollectionDetailsRelayPageQuery' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $49b481e230a25c99$var$_confluenceTemplateCollectionDetailsRelayPageQuery);
const $49b481e230a25c99$export$fcca656ba7c9c75a = (location, partialVars)=>{
    const locale = partialVars?.locale ?? (0, $a8pnN.parseQueryLocale)(location);
    const urlSlug = partialVars?.urlSlug ?? $49b481e230a25c99$var$parseCollectionUrlSlug(location.pathname);
    const relatedCollectionUrlSlugs = partialVars?.relatedCollectionUrlSlugs ?? $49b481e230a25c99$var$RELATED_COLLECTION_URL_SLUGS[urlSlug] ?? $49b481e230a25c99$var$DEFAULT_RELATED_COLLECTION_URL_SLUGS;
    return {
        locale: locale,
        urlSlug: urlSlug,
        relatedCollectionUrlSlugs: relatedCollectionUrlSlugs
    };
};
const $49b481e230a25c99$var$CollectionDetailsContentRelay = ({ queryRef: queryRef })=>{
    const { collections: collections, relatedCollections: relatedCollections } = (0, $hOqV7.usePreloadedQuery)($49b481e230a25c99$export$98e1975bc3089d34, queryRef);
    const collection = (0, $lHB9W.expectContent)(collections.edges[0]?.node);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        "data-testid": "confluence-template-collection-details-content",
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)((0, $jiTf1.CollectionHeaderSection), {
                collection: collection
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_p12fyl33 _19pkidpf _2hwx1wug _otyridpf _18u01wug _q9tovbgk _17arvbgk _1tbzzwfg _6881zwfg"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $UKzss.CollectionAboutSection), {
                        collection: collection
                    }),
                    collection.howToUseThisCollection && /*#__PURE__*/ (0, $loA2J.jsx)((0, $3vcPX.CollectionGuideSection), {
                        collectionGuide: collection.howToUseThisCollection
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)((0, $h6y9u.CollectionRelatedSection), {
                        collections: relatedCollections
                    })
                ]
            })
        ]
    });
};
const $49b481e230a25c99$export$b6f88ef369f9fcd = ({ queryRef: queryRef })=>{
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $lGc56.SharedHeaderFooterContainer), {
        children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $4ktyF.default), {
            children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $iSvIT.Suspense), {
                children: /*#__PURE__*/ (0, $loA2J.jsx)($49b481e230a25c99$var$CollectionDetailsContentRelay, {
                    queryRef: queryRef
                })
            })
        })
    });
};

});
parcelRegister("UKzss", function(module, exports) {

$parcel$export(module.exports, "CollectionAboutSection", function () { return $bfb8d1b4e7288dde$export$47cbf275a64a5835; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");
var $bfb8d1b4e7288dde$var$_collectionAboutSectionRelayFragment;
const $bfb8d1b4e7288dde$var$collectionAboutTitle = null;
const $bfb8d1b4e7288dde$var$collectionAboutWrapper = null;
const $bfb8d1b4e7288dde$var$collectionAboutInfo = null;
const $bfb8d1b4e7288dde$var$collectionAboutStyle = null;
const $bfb8d1b4e7288dde$var$aboutImage = null;

const $bfb8d1b4e7288dde$var$CollectionAboutSectionRelayFragment = $bfb8d1b4e7288dde$var$_collectionAboutSectionRelayFragment !== void 0 ? $bfb8d1b4e7288dde$var$_collectionAboutSectionRelayFragment : ($bfb8d1b4e7288dde$var$_collectionAboutSectionRelayFragment = (parcelRequire("6bd55")), $bfb8d1b4e7288dde$var$_collectionAboutSectionRelayFragment.hash && $bfb8d1b4e7288dde$var$_collectionAboutSectionRelayFragment.hash !== "da9e6616476bf8bc1a7a4460662418fe" && console.error("The definition of 'collectionAboutSectionRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $bfb8d1b4e7288dde$var$_collectionAboutSectionRelayFragment);
const $bfb8d1b4e7288dde$export$47cbf275a64a5835 = ({ collection: collection })=>{
    const { name: name, aboutThisCollectionHeader: aboutThisCollectionHeader, aboutThisCollection: aboutThisCollection, aboutThisCollectionImage: aboutThisCollectionImage } = (0, $hOqV7.useFragment)($bfb8d1b4e7288dde$var$CollectionAboutSectionRelayFragment, collection);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _1q51vbgk _zulp1tcg _1gde1bp4"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _zulp1ylp _2lx21bp4 _y3gn1e5h"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                        className: (0, $esG4f.default)([
                            "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1kzs1k8s _16cb1m1q"
                        ]),
                        children: aboutThisCollectionHeader
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                        className: (0, $esG4f.default)([
                            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf"
                        ]),
                        children: aboutThisCollection
                    })
                ]
            }),
            aboutThisCollectionImage && /*#__PURE__*/ (0, $loA2J.jsx)("img", {
                src: aboutThisCollectionImage.url,
                alt: name ?? aboutThisCollectionImage.name ?? undefined,
                className: (0, $esG4f.default)([
                    "_p12fsb0t _c71luuw1"
                ])
            })
        ]
    });
};

});
parcelRegister("6bd55", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $4e5915a9aa1f54ea$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<ec6b86fa7526dc732175fa80e3b532ba>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $4e5915a9aa1f54ea$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "collectionAboutSectionRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aboutThisCollectionHeader",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "aboutThisCollection",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateImageAsset",
            "kind": "LinkedField",
            "name": "aboutThisCollectionImage",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                },
                {
                    "alias": "name",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "title",
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplateCollection",
    "abstractKey": null
};
$4e5915a9aa1f54ea$var$node.hash = "da9e6616476bf8bc1a7a4460662418fe";
var $4e5915a9aa1f54ea$export$2e2bcd8739ae039 = $4e5915a9aa1f54ea$var$node;

});


parcelRegister("3vcPX", function(module, exports) {

$parcel$export(module.exports, "CollectionGuideSection", function () { return $eb2967957efefacd$export$152a602189556441; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $hOqV7 = parcelRequire("hOqV7");

var $1XyNv = parcelRequire("1XyNv");

var $5VuC0 = parcelRequire("5VuC0");

var $A9zZc = parcelRequire("A9zZc");

var $3FBn4 = parcelRequire("3FBn4");

var $3JcvX = parcelRequire("3JcvX");
var $eb2967957efefacd$var$_collectionGuideSectionRelayFragment;
const $eb2967957efefacd$var$guideSectionStyle = null;
const $eb2967957efefacd$var$stepContainerStyle = null;
const $eb2967957efefacd$var$guideSectionHeading = null;
const $eb2967957efefacd$var$stepHeading = null;
const $eb2967957efefacd$var$stepSubHeading = null;
const $eb2967957efefacd$var$stepContentWrapper = null;
const $eb2967957efefacd$var$stepCardWrapper = null;
const $eb2967957efefacd$var$stepTemplateLinkStyle = null;
const $eb2967957efefacd$var$CollectionDetailStep = ({ step: step })=>{
    const stepTemplateLink = (0, $3FBn4.useLocalizedHref)(`/software/confluence/templates/${step.relatedTemplate?.urlSlug}`);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
        className: (0, $esG4f.default)([
            "_1e0c1txw _1bah1yb4 _6rthys9h _zulp8pqr _1gde1bp4 _8164viql _1ckvidpf"
        ]),
        children: [
            step.relatedTemplate && /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_16jlidpf _1o9zidpf _y3gn1e5h _19pkidpf _2hwx1wug _otyridpf _18u01wug"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $3JcvX.TemplateCard), {
                    template: step.relatedTemplate,
                    background: "url(https://wac-cdn.atlassian.com/misc-assets/webp-images/bg1.svg)"
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
                className: (0, $esG4f.default)([
                    "_1e0c1txw _2lx21bp4"
                ]),
                children: [
                    /*#__PURE__*/ (0, $loA2J.jsx)("h3", {
                        className: (0, $esG4f.default)([
                            "_1wyb1k8s _vwz4viql _k48pbfng _1dyznl7k _syazdtn8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rthzwfg _1cqs1k92 _1bys1k8s"
                        ]),
                        children: step.name
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsx)("h4", {
                        className: (0, $esG4f.default)([
                            "_1wyb1k92 _vwz41k8s _k48pbfng _1dyznl7k _syazdtn8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1tcg _1cqs1j6v _1bys1k92"
                        ]),
                        children: step.stepSubheading
                    }),
                    step.stepDescription && /*#__PURE__*/ (0, $loA2J.jsx)((0, $A9zZc.SanitizedRichText), {
                        innerHTML: step.stepDescription
                    }),
                    /*#__PURE__*/ (0, $loA2J.jsxs)("a", {
                        href: stepTemplateLink,
                        ...(0, $5VuC0.ConfluenceTemplateAnalytics).viewTemplateAnalyticProps(step.relatedTemplate?.urlSlug),
                        className: (0, $esG4f.default)([
                            "_1pfh1tcg _syazrbzz _k48pbfng _4bfu1r31 _1hms8stv _ajmmnqa1 _30l3oelr _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _1053rbzz"
                        ]),
                        children: [
                            /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                ...(0, $1XyNv.ConfluenceTemplateMessages).collectionViewTemplate
                            }),
                            " \u2192"
                        ]
                    })
                ]
            })
        ]
    });
};

const $eb2967957efefacd$var$CollectionGuideSectionRelayFragment = $eb2967957efefacd$var$_collectionGuideSectionRelayFragment !== void 0 ? $eb2967957efefacd$var$_collectionGuideSectionRelayFragment : ($eb2967957efefacd$var$_collectionGuideSectionRelayFragment = (parcelRequire("cJRm4")), $eb2967957efefacd$var$_collectionGuideSectionRelayFragment.hash && $eb2967957efefacd$var$_collectionGuideSectionRelayFragment.hash !== "67408a1c6a9e105ceb80f53fded94380" && console.error("The definition of 'collectionGuideSectionRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $eb2967957efefacd$var$_collectionGuideSectionRelayFragment);
const $eb2967957efefacd$export$152a602189556441 = ({ collectionGuide: collectionGuide })=>{
    const { name: name, collectionSteps: collectionSteps } = (0, $hOqV7.useFragment)($eb2967957efefacd$var$CollectionGuideSectionRelayFragment, collectionGuide);
    return /*#__PURE__*/ (0, $loA2J.jsxs)("section", {
        className: (0, $esG4f.default)([
            "_1pfhys9h _ahbq1wug _12l21wug"
        ]),
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("h2", {
                className: (0, $esG4f.default)([
                    "_1wybahaf _vwz4yn4p _k48pbfng _1dyznl7k _syazdtn8 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ylp _1kzs1k8s _16cb1m1q"
                ]),
                children: name
            }),
            collectionSteps?.map((step, index)=>/*#__PURE__*/ (0, $loA2J.jsx)($eb2967957efefacd$var$CollectionDetailStep, {
                    step: step
                }, `step-${index}`))
        ]
    });
};

});
parcelRegister("cJRm4", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $577baf9aff6e10e8$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<6e8f3226641ecd01dd1a2748d8070e2d>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $577baf9aff6e10e8$var$node = function() {
    var v0 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "metadata": null,
        "name": "collectionGuideSectionRelayFragment",
        "selections": [
            v0 /*: any*/ ,
            {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTemplateCollectionStep",
                "kind": "LinkedField",
                "name": "collectionSteps",
                "plural": true,
                "selections": [
                    v0 /*: any*/ ,
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stepSubheading",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "stepDescription",
                        "storageKey": null
                    },
                    {
                        "alias": null,
                        "args": null,
                        "concreteType": "ContentPlatformTemplate",
                        "kind": "LinkedField",
                        "name": "relatedTemplate",
                        "plural": false,
                        "selections": [
                            {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "urlSlug",
                                "storageKey": null
                            },
                            {
                                "args": null,
                                "kind": "FragmentSpread",
                                "name": "templateCardRelayFragment"
                            }
                        ],
                        "storageKey": null
                    }
                ],
                "storageKey": null
            }
        ],
        "type": "ContentPlatformTemplateCollectionGuide",
        "abstractKey": null
    };
}();
$577baf9aff6e10e8$var$node.hash = "67408a1c6a9e105ceb80f53fded94380";
var $577baf9aff6e10e8$export$2e2bcd8739ae039 = $577baf9aff6e10e8$var$node;

});


parcelRegister("jiTf1", function(module, exports) {

$parcel$export(module.exports, "CollectionHeaderSection", function () { return $88fc94c30fdd6c09$export$e0a60425c82b7176; });

var $loA2J = parcelRequire("loA2J");
parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $hOqV7 = parcelRequire("hOqV7");
var $88fc94c30fdd6c09$var$_collectionHeaderSectionRelayFragment;
const $88fc94c30fdd6c09$var$backgroundStyles = null;
const $88fc94c30fdd6c09$var$collectionHeadingSection = null;
const $88fc94c30fdd6c09$var$collectionTitle = null;
const $88fc94c30fdd6c09$var$collectionHeadline = null;
const $88fc94c30fdd6c09$var$dividerStyle = null;

const $88fc94c30fdd6c09$var$CollectionHeaderSectionRelayFragment = $88fc94c30fdd6c09$var$_collectionHeaderSectionRelayFragment !== void 0 ? $88fc94c30fdd6c09$var$_collectionHeaderSectionRelayFragment : ($88fc94c30fdd6c09$var$_collectionHeaderSectionRelayFragment = (parcelRequire("jDNFa")), $88fc94c30fdd6c09$var$_collectionHeaderSectionRelayFragment.hash && $88fc94c30fdd6c09$var$_collectionHeaderSectionRelayFragment.hash !== "befafdcd78627f0d1d0a92e99ff48adb" && console.error("The definition of 'collectionHeaderSectionRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $88fc94c30fdd6c09$var$_collectionHeaderSectionRelayFragment);
const $88fc94c30fdd6c09$export$e0a60425c82b7176 = ({ collection: collection })=>{
    const { name: name, oneLinerHeadline: oneLinerHeadline } = (0, $hOqV7.useFragment)($88fc94c30fdd6c09$var$CollectionHeaderSectionRelayFragment, collection);
    return /*#__PURE__*/ (0, $loA2J.jsx)("header", {
        className: (0, $esG4f.default)([
            "_1q51vbgk _11q79eel _xc2iidpf _w0geglyw"
        ]),
        children: /*#__PURE__*/ (0, $loA2J.jsxs)("div", {
            className: (0, $esG4f.default)([
                "_y3gn1h6o _p12fyl33 _1q51ys9h _bozgys9h _y4tiys9h _85i51h39 _19pkidpf _2hwx1wug _otyridpf _18u01wug _bfhku67f _144tidpf _q9tovbgk _17arvbgk _1tbzzwfg _6881zwfg"
            ]),
            children: [
                /*#__PURE__*/ (0, $loA2J.jsx)("h1", {
                    className: (0, $esG4f.default)([
                        "_1wyb1wto _vwz41k7u _k48pbfng _syazalr3 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1j6v _flz0yn4p _280z1tnc _so7d8pqr _19q11p2n"
                    ]),
                    children: name
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("p", {
                    className: (0, $esG4f.default)([
                        "_1wyb1k92 _vwz41m1q _k48p1nn1 _syazalr3 _ect41td8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _6rth1ejb _1v871k92 _kuia1m1q _1egl1jfw"
                    ]),
                    children: oneLinerHeadline
                }),
                /*#__PURE__*/ (0, $loA2J.jsx)("hr", {
                    className: (0, $esG4f.default)([
                        "_1e0cglyw _1bsb11ux _19itywev _19pkidpf _2hwx1wug _otyridpf _18u01wug _1mjb1ule"
                    ])
                })
            ]
        })
    });
};

});
parcelRegister("jDNFa", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $045a95c93309696c$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<26a08e7bdf8aa91cc4608f674106c5c1>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $045a95c93309696c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "collectionHeaderSectionRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oneLinerHeadline",
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplateCollection",
    "abstractKey": null
};
$045a95c93309696c$var$node.hash = "befafdcd78627f0d1d0a92e99ff48adb";
var $045a95c93309696c$export$2e2bcd8739ae039 = $045a95c93309696c$var$node;

});


parcelRegister("h6y9u", function(module, exports) {

$parcel$export(module.exports, "CollectionRelatedSection", function () { return $1e222f5ab5341c10$export$87a43c2b2ebc1974; });

var $loA2J = parcelRequire("loA2J");

var $iSvIT = parcelRequire("iSvIT");

var $esG4f = parcelRequire("esG4f");

var $dFnC9 = parcelRequire("dFnC9");

var $hOqV7 = parcelRequire("hOqV7");

var $1XyNv = parcelRequire("1XyNv");

var $5VuC0 = parcelRequire("5VuC0");

var $3FBn4 = parcelRequire("3FBn4");

var $7R6zG = parcelRequire("7R6zG");
var $1e222f5ab5341c10$var$_collectionRelatedSectionRelayFragment;
const $1e222f5ab5341c10$var$sectionStyle = null;
const $1e222f5ab5341c10$var$headingStyle = null;
const $1e222f5ab5341c10$var$collectionsBox = null;
const $1e222f5ab5341c10$var$hrefStyle = null;
const $1e222f5ab5341c10$var$backWrapper = null;

const $1e222f5ab5341c10$var$CollectionRelatedSectionRelayFragment = $1e222f5ab5341c10$var$_collectionRelatedSectionRelayFragment !== void 0 ? $1e222f5ab5341c10$var$_collectionRelatedSectionRelayFragment : ($1e222f5ab5341c10$var$_collectionRelatedSectionRelayFragment = (parcelRequire("3iyZs")), $1e222f5ab5341c10$var$_collectionRelatedSectionRelayFragment.hash && $1e222f5ab5341c10$var$_collectionRelatedSectionRelayFragment.hash !== "5bd7f55c40f6ac8524e729498ebc830d" && console.error("The definition of 'collectionRelatedSectionRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $1e222f5ab5341c10$var$_collectionRelatedSectionRelayFragment);
const $1e222f5ab5341c10$export$87a43c2b2ebc1974 = ({ collections: collections })=>{
    const data = (0, $hOqV7.useFragment)($1e222f5ab5341c10$var$CollectionRelatedSectionRelayFragment, collections).edges;
    const viewAllHref = (0, $3FBn4.useLocalizedHref)("/software/confluence/templates");
    const firstTwoCollections = data?.slice(0, 2);
    if (!firstTwoCollections || firstTwoCollections.length === 0) return null;
    return /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iSvIT.Fragment), {
        children: [
            /*#__PURE__*/ (0, $loA2J.jsx)("section", {
                "data-testid": "confluence-template-collection-related",
                className: (0, $esG4f.default)([
                    "_1q5116xz"
                ]),
                children: firstTwoCollections && firstTwoCollections.length > 0 && /*#__PURE__*/ (0, $loA2J.jsxs)((0, $iSvIT.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $loA2J.jsxs)("h3", {
                            className: (0, $esG4f.default)([
                                "_1wyb1k8s _vwz4viql _k48pbfng _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1cqs1k92 _1bys1k8s"
                            ]),
                            children: [
                                /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                    ...(0, $1XyNv.ConfluenceTemplateMessages).moreCollections
                                }),
                                /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                                    href: viewAllHref,
                                    ...(0, $5VuC0.ConfluenceTemplateAnalytics).viewAllCollections(),
                                    className: (0, $esG4f.default)([
                                        "_syazrbzz _k48pbfng _1wyb1j6v _vwz41k92 _4bfu1r31 _1hms8stv _ajmmnqa1 _ahbq7vkz _30l3oelr _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _1053rbzz"
                                    ]),
                                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                                        ...(0, $1XyNv.ConfluenceTemplateMessages).viewAllCollections
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                            className: (0, $esG4f.default)([
                                "_1q51zwfg _1e0c1txw _zulpzwfg _1n261g80 _81647vkz"
                            ]),
                            children: firstTwoCollections.map(({ node: collection })=>/*#__PURE__*/ (0, $loA2J.jsx)((0, $7R6zG.CollectionCardRelay), {
                                    collection: collection
                                }, collection.collectionId))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $loA2J.jsx)("div", {
                className: (0, $esG4f.default)([
                    "_y3gn1h6o _1q5116xz _85i516xz"
                ]),
                children: /*#__PURE__*/ (0, $loA2J.jsx)("a", {
                    href: viewAllHref,
                    ...(0, $5VuC0.ConfluenceTemplateAnalytics).backToGalleryAnalyticProps(),
                    className: (0, $esG4f.default)([
                        "_syazrbzz _k48pbfng _1wyb1j6v _vwz41k92 _4bfu1r31 _1hms8stv _ajmmnqa1 _ahbq7vkz _30l3oelr _9oik1r31 _1bnxglyw _jf4cnqa1 _1nrm1r31 _c2waglyw _1iohnqa1 _1a3b1r31 _4fprglyw _5goinqa1 _1053rbzz"
                    ]),
                    children: /*#__PURE__*/ (0, $loA2J.jsx)((0, $dFnC9.default), {
                        ...(0, $1XyNv.ConfluenceTemplateMessages).backToGallery
                    })
                })
            })
        ]
    });
};

});
parcelRegister("7R6zG", function(module, exports) {

$parcel$export(module.exports, "CollectionCardRelay", function () { return $c4399ffc87098dd9$export$38139bbb746460cb; });

var $loA2J = parcelRequire("loA2J");

var $hOqV7 = parcelRequire("hOqV7");

var $iO0GF = parcelRequire("iO0GF");
var $c4399ffc87098dd9$var$_collectionCardRelayFragment;

const $c4399ffc87098dd9$var$CollectionCardFragment = $c4399ffc87098dd9$var$_collectionCardRelayFragment !== void 0 ? $c4399ffc87098dd9$var$_collectionCardRelayFragment : ($c4399ffc87098dd9$var$_collectionCardRelayFragment = (parcelRequire("5gVSg")), $c4399ffc87098dd9$var$_collectionCardRelayFragment.hash && $c4399ffc87098dd9$var$_collectionCardRelayFragment.hash !== "0f54757384168a88b00435ae177e96f2" && console.error("The definition of 'collectionCardRelayFragment' appears to have changed. Run `relay-compiler` to update the generated files to receive the expected data."), $c4399ffc87098dd9$var$_collectionCardRelayFragment);
const $c4399ffc87098dd9$export$38139bbb746460cb = ({ collection: collection })=>{
    const data = (0, $hOqV7.useFragment)($c4399ffc87098dd9$var$CollectionCardFragment, collection);
    return /*#__PURE__*/ (0, $loA2J.jsx)((0, $iO0GF.CollectionCard), {
        urlSlug: data.urlSlug,
        templateCount: data.howToUseThisCollection?.collectionSteps?.length ?? 0,
        name: data.name ?? ""
    });
};

});
parcelRegister("5gVSg", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $0dacae32c1e0c87c$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<daea851b129b0de57fae71b123067139>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $0dacae32c1e0c87c$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "collectionCardRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "collectionId",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "urlSlug",
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateImageAsset",
            "kind": "LinkedField",
            "name": "collectionIcon",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "url",
                    "storageKey": null
                }
            ],
            "storageKey": null
        },
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateCollectionGuide",
            "kind": "LinkedField",
            "name": "howToUseThisCollection",
            "plural": false,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateCollectionStep",
                    "kind": "LinkedField",
                    "name": "collectionSteps",
                    "plural": true,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "__typename",
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplateCollection",
    "abstractKey": null
};
$0dacae32c1e0c87c$var$node.hash = "0f54757384168a88b00435ae177e96f2";
var $0dacae32c1e0c87c$export$2e2bcd8739ae039 = $0dacae32c1e0c87c$var$node;

});


parcelRegister("3iyZs", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $1ca1545dafb6eda1$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<fb466bbeb80313f5897907cccc880cce>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $1ca1545dafb6eda1$var$node = {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "collectionRelatedSectionRelayFragment",
    "selections": [
        {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateCollectionResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
                {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTemplateCollection",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "collectionId",
                            "storageKey": null
                        },
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "collectionCardRelayFragment"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "storageKey": null
        }
    ],
    "type": "ContentPlatformTemplateCollectionContentSearchConnection",
    "abstractKey": null
};
$1ca1545dafb6eda1$var$node.hash = "5bd7f55c40f6ac8524e729498ebc830d";
var $1ca1545dafb6eda1$export$2e2bcd8739ae039 = $1ca1545dafb6eda1$var$node;

});


parcelRegister("8wWZU", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $46cb8301c16dd4d2$export$2e2bcd8739ae039; });
/**
 * @generated SignedSource<<e0657ddb1a7345d42adacc584f2e2a83>>
 * @lightSyntaxTransform
 * @nogrep
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $46cb8301c16dd4d2$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "locale"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "relatedCollectionUrlSlugs"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "urlSlug"
    }, v3 = {
        "kind": "Literal",
        "name": "fieldNamed",
        "value": "urlSlug"
    }, v4 = {
        "items": [
            {
                "kind": "Variable",
                "name": "withLocales.0",
                "variableName": "locale"
            }
        ],
        "kind": "ListValue",
        "name": "withLocales"
    }, v5 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 1
                        },
                        {
                            "fields": [
                                v3 /*: any*/ ,
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "havingValues.0",
                                            "variableName": "urlSlug"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "havingValues"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "where"
                        },
                        v4 /*: any*/ 
                    ],
                    "kind": "ObjectValue",
                    "name": "queries"
                }
            ],
            "kind": "ObjectValue",
            "name": "search"
        }
    ], v6 = [
        {
            "fields": [
                {
                    "fields": [
                        {
                            "kind": "Literal",
                            "name": "first",
                            "value": 2
                        },
                        {
                            "fields": [
                                v3 /*: any*/ ,
                                {
                                    "kind": "Variable",
                                    "name": "havingValues",
                                    "variableName": "relatedCollectionUrlSlugs"
                                }
                            ],
                            "kind": "ObjectValue",
                            "name": "where"
                        },
                        v4 /*: any*/ 
                    ],
                    "kind": "ObjectValue",
                    "name": "queries"
                }
            ],
            "kind": "ObjectValue",
            "name": "search"
        }
    ], v7 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "name",
        "storageKey": null
    }, v8 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "url",
        "storageKey": null
    }, v9 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "urlSlug",
        "storageKey": null
    }, v10 = {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "__typename",
        "storageKey": null
    }, v11 = [
        v7 /*: any*/ 
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "metadata": null,
            "name": "confluenceTemplateCollectionDetailsRelayPageQuery",
            "selections": [
                {
                    "alias": "collections",
                    "args": v5 /*: any*/ ,
                    "concreteType": "ContentPlatformTemplateCollectionContentSearchConnection",
                    "kind": "LinkedField",
                    "name": "templateCollections",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentPlatformTemplateCollectionResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentPlatformTemplateCollection",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "collectionHeaderSectionRelayFragment"
                                        },
                                        {
                                            "args": null,
                                            "kind": "FragmentSpread",
                                            "name": "collectionAboutSectionRelayFragment"
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplateCollectionGuide",
                                            "kind": "LinkedField",
                                            "name": "howToUseThisCollection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "args": null,
                                                    "kind": "FragmentSpread",
                                                    "name": "collectionGuideSectionRelayFragment"
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "relatedCollections",
                    "args": v6 /*: any*/ ,
                    "concreteType": "ContentPlatformTemplateCollectionContentSearchConnection",
                    "kind": "LinkedField",
                    "name": "templateCollections",
                    "plural": false,
                    "selections": [
                        {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "collectionRelatedSectionRelayFragment"
                        }
                    ],
                    "storageKey": null
                }
            ],
            "type": "Query",
            "abstractKey": null
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "confluenceTemplateCollectionDetailsRelayPageQuery",
            "selections": [
                {
                    "alias": "collections",
                    "args": v5 /*: any*/ ,
                    "concreteType": "ContentPlatformTemplateCollectionContentSearchConnection",
                    "kind": "LinkedField",
                    "name": "templateCollections",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentPlatformTemplateCollectionResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentPlatformTemplateCollection",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        v7 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "oneLinerHeadline",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "aboutThisCollectionHeader",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "aboutThisCollection",
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplateImageAsset",
                                            "kind": "LinkedField",
                                            "name": "aboutThisCollectionImage",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ ,
                                                {
                                                    "alias": "name",
                                                    "args": null,
                                                    "kind": "ScalarField",
                                                    "name": "title",
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplateCollectionGuide",
                                            "kind": "LinkedField",
                                            "name": "howToUseThisCollection",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentPlatformTemplateCollectionStep",
                                                    "kind": "LinkedField",
                                                    "name": "collectionSteps",
                                                    "plural": true,
                                                    "selections": [
                                                        v7 /*: any*/ ,
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "stepSubheading",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "kind": "ScalarField",
                                                            "name": "stepDescription",
                                                            "storageKey": null
                                                        },
                                                        {
                                                            "alias": null,
                                                            "args": null,
                                                            "concreteType": "ContentPlatformTemplate",
                                                            "kind": "LinkedField",
                                                            "name": "relatedTemplate",
                                                            "plural": false,
                                                            "selections": [
                                                                v9 /*: any*/ ,
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "templateId",
                                                                    "storageKey": null
                                                                },
                                                                v7 /*: any*/ ,
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "pluginModuleKey",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "kind": "ScalarField",
                                                                    "name": "previewBlurb",
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": "ContentPlatformTaxonomyTemplateType",
                                                                    "kind": "LinkedField",
                                                                    "name": "templateType",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "id",
                                                                            "storageKey": null
                                                                        },
                                                                        {
                                                                            "alias": null,
                                                                            "args": null,
                                                                            "kind": "ScalarField",
                                                                            "name": "templateTypeName",
                                                                            "storageKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                },
                                                                {
                                                                    "alias": null,
                                                                    "args": null,
                                                                    "concreteType": null,
                                                                    "kind": "LinkedField",
                                                                    "name": "contributor",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v10 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": v11 /*: any*/ ,
                                                                            "type": "ContentPlatformOrganization",
                                                                            "abstractKey": null
                                                                        },
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "alias": null,
                                                                                    "args": null,
                                                                                    "concreteType": "ContentPlatformOrganization",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "organization",
                                                                                    "plural": false,
                                                                                    "selections": v11 /*: any*/ ,
                                                                                    "storageKey": null
                                                                                }
                                                                            ],
                                                                            "type": "ContentPlatformAuthor",
                                                                            "abstractKey": null
                                                                        }
                                                                    ],
                                                                    "storageKey": null
                                                                }
                                                            ],
                                                            "storageKey": null
                                                        }
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                },
                {
                    "alias": "relatedCollections",
                    "args": v6 /*: any*/ ,
                    "concreteType": "ContentPlatformTemplateCollectionContentSearchConnection",
                    "kind": "LinkedField",
                    "name": "templateCollections",
                    "plural": false,
                    "selections": [
                        {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentPlatformTemplateCollectionResultEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                                {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentPlatformTemplateCollection",
                                    "kind": "LinkedField",
                                    "name": "node",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "collectionId",
                                            "storageKey": null
                                        },
                                        v7 /*: any*/ ,
                                        v9 /*: any*/ ,
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplateImageAsset",
                                            "kind": "LinkedField",
                                            "name": "collectionIcon",
                                            "plural": false,
                                            "selections": [
                                                v8 /*: any*/ 
                                            ],
                                            "storageKey": null
                                        },
                                        {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "ContentPlatformTemplateCollectionGuide",
                                            "kind": "LinkedField",
                                            "name": "howToUseThisCollection",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "alias": null,
                                                    "args": null,
                                                    "concreteType": "ContentPlatformTemplateCollectionStep",
                                                    "kind": "LinkedField",
                                                    "name": "collectionSteps",
                                                    "plural": true,
                                                    "selections": [
                                                        v10 /*: any*/ 
                                                    ],
                                                    "storageKey": null
                                                }
                                            ],
                                            "storageKey": null
                                        }
                                    ],
                                    "storageKey": null
                                }
                            ],
                            "storageKey": null
                        }
                    ],
                    "storageKey": null
                }
            ]
        },
        "params": {
            "cacheID": "2b396062365f32e3132c45d8b5e09dfd",
            "id": null,
            "metadata": {},
            "name": "confluenceTemplateCollectionDetailsRelayPageQuery",
            "operationKind": "query",
            "text": 'query confluenceTemplateCollectionDetailsRelayPageQuery(\n  $locale: String!\n  $urlSlug: String!\n  $relatedCollectionUrlSlugs: [String!]!\n) {\n  collections: templateCollections(search: {queries: {first: 1, withLocales: [$locale], where: {fieldNamed: "urlSlug", havingValues: [$urlSlug]}}}) {\n    edges {\n      node {\n        ...collectionHeaderSectionRelayFragment\n        ...collectionAboutSectionRelayFragment\n        howToUseThisCollection {\n          ...collectionGuideSectionRelayFragment\n        }\n      }\n    }\n  }\n  relatedCollections: templateCollections(search: {queries: {first: 2, withLocales: [$locale], where: {fieldNamed: "urlSlug", havingValues: $relatedCollectionUrlSlugs}}}) {\n    ...collectionRelatedSectionRelayFragment\n  }\n}\n\nfragment collectionAboutSectionRelayFragment on ContentPlatformTemplateCollection {\n  name\n  aboutThisCollectionHeader\n  aboutThisCollection\n  aboutThisCollectionImage {\n    url\n    name: title\n  }\n}\n\nfragment collectionCardRelayFragment on ContentPlatformTemplateCollection {\n  collectionId\n  name\n  urlSlug\n  collectionIcon {\n    url\n  }\n  howToUseThisCollection {\n    collectionSteps {\n      __typename\n    }\n  }\n}\n\nfragment collectionGuideSectionRelayFragment on ContentPlatformTemplateCollectionGuide {\n  name\n  collectionSteps {\n    name\n    stepSubheading\n    stepDescription\n    relatedTemplate {\n      urlSlug\n      ...templateCardRelayFragment\n    }\n  }\n}\n\nfragment collectionHeaderSectionRelayFragment on ContentPlatformTemplateCollection {\n  name\n  oneLinerHeadline\n}\n\nfragment collectionRelatedSectionRelayFragment on ContentPlatformTemplateCollectionContentSearchConnection {\n  edges {\n    node {\n      collectionId\n      ...collectionCardRelayFragment\n    }\n  }\n}\n\nfragment templateCardRelayFragment on ContentPlatformTemplate {\n  templateId\n  name\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateType {\n    id\n    templateTypeName\n  }\n  contributor {\n    __typename\n    ... on ContentPlatformOrganization {\n      name\n    }\n    ... on ContentPlatformAuthor {\n      organization {\n        name\n      }\n    }\n  }\n}\n'
        }
    };
}();
$46cb8301c16dd4d2$var$node.hash = "732359a6944a3fa6a17b0037c5a47b87";
var $46cb8301c16dd4d2$export$2e2bcd8739ae039 = $46cb8301c16dd4d2$var$node;

});




var $2A2ZL = parcelRequire("2A2ZL");

var $hWj1i = parcelRequire("hWj1i");

var $jEcgL = parcelRequire("jEcgL");
(0, $2A2ZL.init)((0, $hWj1i.ConfluenceTemplateCollectionDetailsRelayPage), (0, $jEcgL.ConfluenceTemplateCollectionDetailsRelayPageQuery), (0, $jEcgL.getConfluenceTemplateCollectionDetailsRelayPageQueryVars)(window.location));


//# sourceMappingURL=confluence-template-collection-details-relay-page.9df6d28c.js.map
